import { jsx } from 'react/jsx-runtime';

const SvgFormCheckCircleOutlined = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M16.29 8.29 11 13.59l-2.79-2.8-1.42 1.42 4.21 4.2 6.71-6.7-1.42-1.42ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z" }) }));

export { SvgFormCheckCircleOutlined as default };
//# sourceMappingURL=FormCheckCircleOutlined.es.js.map
